var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExitFullscreen = function SvgExitFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9a1.5 1.5 0 0 0 1.5 1.5h5.25a.75.75 0 0 0 0-1.5H15V3.75a.75.75 0 0 0-1.5 0V9ZM10.5 15A1.5 1.5 0 0 0 9 13.5H3.75a.75.75 0 0 0 0 1.5H9v5.25a.75.75 0 0 0 1.5 0V15ZM10.5 9A1.5 1.5 0 0 1 9 10.5H3.75a.75.75 0 0 1 0-1.5H9V3.75a.75.75 0 0 1 1.5 0V9ZM15 13.5a1.5 1.5 0 0 0-1.5 1.5v5.25a.75.75 0 0 0 1.5 0V15h5.25a.75.75 0 0 0 0-1.5H15Z"
  })));
};

export default SvgExitFullscreen;